import useAuth from "./useAuth";
import { SubscriptionStatus } from "../types/subscription";

/**
 * True when the active association's subscription has been frozen by a
 * superadmin and the current user should be locked out of the app.
 *
 * Superadmins are exempt — they need to reach a suspended association to
 * unfreeze it from the management panel.
 *
 * Note this reads the UPPERCASE status union from `types/subscription`, which
 * is what `GET /subscriptions/:id/status` returns. The lowercase enum in
 * `redux/slices/subscription` describes entity-shaped rows and never matches
 * here.
 */
const useIsAssociationSuspended = (): boolean => {
  const { associationSubscription, currentUser } = useAuth();

  if (currentUser?.isSuperAdmin) return false;

  return associationSubscription?.status === SubscriptionStatus.SUSPENDED;
};

export default useIsAssociationSuspended;
